import React, { Component } from 'react'
import SectionHeader from './SectionHeader'
import Card2 from '../cards/Card2'
import cloud1 from '../../images/cloud1.png'
import FigmaSvg from '../icons/FigmaSvg';
import CodeSvg from '../icons/CodeSvg';
import SeoSvg from '../icons/SeoSvg';
import ECommersSvg from '../icons/ECommersSvg';
import PhoneSvg2 from '../icons/PhoneSvg2';

export class ServicesMP extends Component {
    render() {
        const { className, card_shadow } = this.props;
        return (
            <section className={`${className}  pt-[52px] pb-[42px]`} >
                <div className='container'>
                    <div className='flex flex-col gap-[12px] items-center'>
                        <span className='text-[var(--orange)] text-[16px] font-[600]'>Biz Nə Təklif Edirik? </span>

                        <SectionHeader
                            title='Xidmətlər'
                            className="max-w-[900px] text-center max-[1100px]:w-[700px] max-[950px]:max-w-[600px] max-[620px]:w-[400px] max-[400px]:w-[300px] max-[320px]:w-[260px]"
                        />

                    </div>

                    <div className='mt-[32px]'>
                        <div className='grid grid-cols-2 gap-[20px] max-[650px]:grid-cols-1'>
                            <Card2
                                className="bg-[#fff]"
                                image={cloud1}
                                title="UI/UX dizayn"
                                text="Saytınızın vizual görünüşü müştərilərinizə ilk təəssüratı yaradır. Biz sizin işinizin fərqini əks etdirən, müasir və cəlbedici dizaynlar hazırlayırıq. Sizə uyğun bir dizayn haqqında danışmaq istəyirsiniz? Biz hazırıq!"
                                shadow={card_shadow}
                                icon={<FigmaSvg width="40" height="40" fill="#0E38B1" />}
                            />
                            <Card2
                                className="bg-[#fff]"
                                image={cloud1}
                                title="Veb saytların hazırlanması"
                                text="Texnologiya sürətlə inkişaf edir, biz də sizinlə birlikdə addım atırıq. Saytınızın sürətli, etibarlı və mobil cihazlara tam uyğun şəkildə işləməsini təmin edirik. Proqramlaşdırma ilə bağlı suallarınız var? Biz buradayıq!"
                                shadow={card_shadow}
                                icon={<CodeSvg width="40" height="40" fill="#0E38B1" />}
                            />
                        </div>

                        <div className='grid grid-cols-3 gap-[20px] mt-[20px] max-[950px]:grid-cols-2 max-[650px]:grid-cols-1'>
                            <Card2
                                className="bg-[#fff]"
                                image={cloud1}
                                title="SEO Xidmətləri"
                                text="Saytınız gözəldir, amma axtarış motorlarında görünmür? Biz bu problemi həll edirik! Sizin üçün uyğun SEO strategiyası ilə saytınızın Google kimi platformalarda görünürlüğünü artırırıq. SEO-nu sizin üçün sadə və anlaşılan edirik."
                                shadow={card_shadow}
                                icon={<SeoSvg width="40" height="40" fill="#0E38B1" />}
                            />
                            <Card2
                                className="bg-[#fff]"
                                image={cloud1}
                                title="E-ticarət Saytları"
                                text="Onlayn satış etmək istəyirsiniz? Biz sizin e-ticarət saytınızı bütün lazımi funksiyalarla təchiz edirik ki, müştəriləriniz rahatlıqla alış-veriş edə bilsin."
                                shadow={card_shadow}
                                icon={<ECommersSvg width="40" height="40" fill="#0E38B1" />}
                            />
                            <Card2
                                className="bg-[#fff]"
                                image={cloud1}
                                title="Mobil tətbiqlərin hazırlanması"
                                text="Biznesinizi sadələşdirəcək xüsusi veb tətbiqlərə ehtiyacınız var? Biz sizin üçün tam uyğun, funksional tətbiqlər hazırlayırıq. Gəlin sizin layihənizi birlikdə müzakirə edək!"
                                shadow={card_shadow}
                                icon={<PhoneSvg2 width="40" height="40" fill="#0E38B1" />}

                            />
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default ServicesMP